import React from "react";

const SectionRowSkeleton = ({ withQuestions }) => (
    <div className="rounded-xl bg-gray-50 p-3">
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
                <div className="h-3.5 w-3.5 bg-gray-200 rounded" />
                <div className="h-3.5 w-20 bg-gray-200 rounded" />
            </div>
            <div className="flex items-center gap-2">
                <div className="h-4 w-6 bg-gray-200 rounded-full" />
                <div className="h-3.5 w-3.5 bg-gray-200 rounded" />
            </div>
        </div>
        {withQuestions && (
            <div className="mt-3 space-y-2 pl-1">
                {[0, 1, 2].map((row) => (
                    <div key={row} className="flex items-center gap-2">
                        <div className="h-5 w-5 shrink-0 rounded-md bg-gray-200" />
                        <div className="h-3 w-full bg-gray-200 rounded" />
                    </div>
                ))}
            </div>
        )}
    </div>
);

export const SidebarSkeleton = () => (
    <div className="flex flex-col gap-4 animate-pulse">
        <div className="rounded-xl bg-gray-100 p-4">
            <div className="h-4 w-3/4 rounded bg-gray-200" />
            <div className="mt-2 h-3 w-full rounded bg-gray-200" />
        </div>

        <div>
            <div className="mb-2 h-2.5 w-16 rounded bg-gray-100" />
            <div className="space-y-2">
                <SectionRowSkeleton withQuestions />
                <SectionRowSkeleton />
            </div>
        </div>
    </div>
);

const QuestionCardSkeleton = () => (
    <div className="rounded-2xl border border-gray-100 bg-white shadow-sm">
        <div className="flex items-center justify-between border-b border-gray-50 px-6 py-3">
            <div className="flex items-center gap-2">
                <div className="h-5 w-9 rounded-full bg-gray-200" />
                <div className="h-3 w-40 bg-gray-100 rounded" />
            </div>
            <div className="flex items-center gap-1">
                <div className="h-8 w-8 rounded-lg bg-gray-100" />
                <div className="h-8 w-8 rounded-lg bg-gray-100" />
            </div>
        </div>

        <div className="px-6 pb-2 pt-4">
            <div className="h-5 w-2/3 bg-gray-200 rounded" />
        </div>

        <div className="space-y-6 px-6 pb-6">
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {[0, 1, 2].map((i) => (
                    <div key={i}>
                        <div className="mb-1.5 h-2.5 w-16 bg-gray-100 rounded" />
                        <div className="h-9 w-full rounded-lg bg-gray-100" />
                    </div>
                ))}
            </div>

            <div className="space-y-2">
                {[0, 1, 2].map((i) => (
                    <div
                        key={i}
                        className="h-10 w-full rounded-lg border border-gray-100 bg-gray-50"
                    />
                ))}
            </div>

            <div className="flex items-center justify-end border-t border-gray-100 pt-4">
                <div className="h-6 w-11 rounded-full bg-gray-200" />
            </div>
        </div>
    </div>
);

export const ContentSkeleton = () => (
    <div className="space-y-6 animate-pulse">
        <div className="flex items-start justify-between gap-4 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="space-y-2">
                <div className="h-3 w-32 bg-gray-100 rounded" />
                <div className="h-7 w-40 bg-gray-200 rounded" />
                <div className="h-3 w-56 bg-gray-100 rounded" />
            </div>
            <div className="h-10 w-36 rounded-full bg-gray-200" />
        </div>

        <div className="flex items-center gap-2 rounded-2xl border border-gray-100 bg-white p-2 shadow-sm">
            <div className="h-11 w-40 rounded-xl bg-gray-100" />
            <div className="h-11 w-32 rounded-xl bg-gray-100" />
        </div>

        {[0, 1, 2].map((i) => (
            <QuestionCardSkeleton key={i} />
        ))}
    </div>
);